(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-locked"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
const url = new URL(window.location.href);
if (url.hash) {
document.addEventListener(
'DOMContentLoaded',
() => {
const card = document.getElementById(url.hash.slice(1));
if (card) {
card.scrollIntoView({ behavior: 'instant' });
}
},
{ once: true }
);
}

// ==== OVERLAY SU CARD-GALLERY — banner sconto + badge stock ====
// Iniettati via JS dentro .card-gallery (funziona con qualsiasi aspect-ratio)

function __injectDiscountStrip(card) {
  if (!card || card.dataset.stripDone === '1') return;
  const pct = card.dataset.discountPct;
  const save = card.dataset.discountSave;
  if (!pct) return;
  const gallery = card.querySelector('.card-gallery');
  if (!gallery) return;
  if (gallery.querySelector('.custom-discount-strip')) { card.dataset.stripDone = '1'; return; }
  const strip = document.createElement('div');
  strip.className = 'custom-discount-strip';
  strip.setAttribute('aria-hidden', 'true');
  strip.innerHTML =
    '<span class="custom-discount-strip__pct">&minus;' + pct + '%</span>' +
    '<span class="custom-discount-strip__save">Risparmi ' + save + '</span>';
  gallery.appendChild(strip);
  card.dataset.stripDone = '1';
}

function __injectStockBadge(card) {
  if (!card || card.dataset.stockBadgeDone === '1') return;
  const count = card.dataset.stockCount;
  if (!count) return;
  const gallery = card.querySelector('.card-gallery');
  if (!gallery) return;
  if (gallery.querySelector('.custom-stock-badge')) { card.dataset.stockBadgeDone = '1'; return; }
  const badge = document.createElement('div');
  badge.className = 'custom-stock-badge';
  badge.setAttribute('aria-hidden', 'true');
  badge.textContent = count === '1' ? 'Ultimo pezzo' : 'Ultimi ' + count + ' pezzi';
  gallery.appendChild(badge);
  card.dataset.stockBadgeDone = '1';
}

function __initCardOverlays() {
  document.querySelectorAll('.custom-grid-card[data-discount-pct]').forEach(__injectDiscountStrip);
  document.querySelectorAll('.custom-grid-card[data-stock-count]').forEach(__injectStockBadge);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', __initCardOverlays);
} else {
  __initCardOverlays();
}

// Gestisce card aggiunte dopo (infinite scroll, cambio filtri)
const __resultsRoot = document.querySelector('results-list');
if (__resultsRoot && window.MutationObserver) {
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches) {
          if (node.matches('.custom-grid-card[data-discount-pct]')) __injectDiscountStrip(node);
          if (node.matches('.custom-grid-card[data-stock-count]')) __injectStockBadge(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.custom-grid-card[data-discount-pct]').forEach(__injectDiscountStrip);
          node.querySelectorAll('.custom-grid-card[data-stock-count]').forEach(__injectStockBadge);
        }
      });
    });
  }).observe(__resultsRoot, { childList: true, subtree: true });
}

  } catch(e) { console.error(e); }
})();
})();
